import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useAssignableCompanyRolesQuery() {
  return useQuery({
    queryKey: ['assignableCompanyRoles'],
    queryFn: async () => {
      const response = await axios.get('/assignable_company_roles');
      return response.data;
    },
    select: (data) => formatData({ data }),
  });
}
